// extracted by mini-css-extract-plugin
module.exports = {"container":"PageNotFound_container__2yYWB","notFound":"PageNotFound_notFound__nlOTP","trustpilot":"PageNotFound_trustpilot__FUh2I","brands":"PageNotFound_brands__AWZnP"};